import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-select-consolidation-carrier',
  templateUrl: './select-consolidation-carrier.component.html',
  styleUrls: ['./select-consolidation-carrier.component.scss']
})
export class SelectConsolidationCarrierComponent {
  @Input() lading_consolidation_uuid: string | undefined | null;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();

  carrier_form: FormGroup = this.fb.group({
    carrier_uuid: ['', Validators.required],
    carrier_name: ['', Validators.required],
    carrier_address_uuid: ['', Validators.required]
  });

  constructor(private fb: FormBuilder, private http: HttpClient){}

  onCloseModal(){
    this.closeModal.emit();
  }

  onSubmit(){
    
  }
}
